var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryingSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crying-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.8148 17.7C21.5251 18.4587 18.9941 20.5432 16.6523 22.8014",
    stroke: "#202020",
    strokeOpacity: 0.9,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.0781 17.955C40.9089 17.9623 43.169 21.5992 43.9448 22.5463",
    stroke: "#202020",
    strokeOpacity: 0.9,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.0078 28.9074C24.987 31.1097 28.0134 30.4237 29.9151 27.3928",
    stroke: "#202020",
    strokeOpacity: 0.9,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.0547 27.903C38.96 30.1642 40.7079 30.2365 42.6663 28.3527",
    stroke: "#202020",
    strokeOpacity: 0.9,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.8555 39.281C31.0114 37.1121 33.8935 37.2869 36.8033 40.6566",
    stroke: "#202020",
    strokeOpacity: 0.9,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.6966 32.4944C23.8417 45.3897 8.70121 47.0037 16.276 33.7152",
    stroke: "#202020",
    strokeOpacity: 0.9,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryingSvgrepoCom1);
export default __webpack_public_path__ + "static/media/crying-svgrepo-com 1.8e484fcbddf0487cd4696d01b628c710.svg";
export { ForwardRef as ReactComponent };